import React from "react";
import "./News.scss";
import SideMenu from "../../components/SideMenu/SideMenu";
import { useStoreState, useStoreActions } from "easy-peasy";
import FrontPageCard from "../../components/FrontPageCards/Card";

const News = () => {
  const news = useStoreState((state) => state.api.apis);
  const totalCount = useStoreState((state) => state.api.totalCount);
  const pageNumber = useStoreState((state) => state.api.pageNumber);
  const getApis = useStoreActions((actions) => actions.api.getApis);
  const setPageNumber = useStoreActions((actions) => actions.api.setPageNumber);
  const namberOfPages = [...Array(Math.ceil(totalCount / 5)).keys()].map(
    (el) => el + 1
  );

  const nextPage = async () => {
    if (pageNumber < namberOfPages[namberOfPages.length - 1]) {
      await getApis({
        limit: 5,
        sort: { date: "DESC" },
        start: 5 * pageNumber,
      });
      setPageNumber(pageNumber + 1);
    }
  };

  const prevPage = async () => {
    if (pageNumber > 1) {
      await getApis({
        limit: 5,
        sort: { date: "DESC" },
        start: 5 * (pageNumber - 2),
      });
      setPageNumber(pageNumber - 1);
    }
  };

  const goToPage = async (numb) => {
    await getApis({
      limit: 5,
      sort: { date: "DESC" },
      start: 5 * (numb - 1),
    });
    setPageNumber(numb);
  };

  return (
    <div className="mainNews">
      <div className="navLine"></div>
      <div className="container">
        <SideMenu />
        <div className="main">
          <div className="header">Новости</div>
          <div className="cardsContainer">
            {news.map((el, index) => (
              <React.Fragment key={index}>
                <FrontPageCard card={el} news={true} />
                {index < news.length - 1 && <div className="divider"></div>}
              </React.Fragment>
            ))}
          </div>
          <div className="pagination">
            <span className="material-icons leftBtn" onClick={() => prevPage()}>
              arrow_back_ios
            </span>
            {namberOfPages.map((el, index) => (
              <span
                key={index}
                className={pageNumber == el ? "active numbers" : "numbers"}
                onClick={() => goToPage(el)}
              >
                {el}
              </span>
            ))}

            <span className="material-icons rghtBtn" onClick={() => nextPage()}>
              arrow_forward_ios
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

News.getInitialProps = async (props) => {
  if (props.isServer) {
    await props.store.dispatch.api.getApis({
      limit: 5,
      sort: { date: "DESC" },
    });
    await props.store.dispatch.api.getApisCount();
  } else {
    const store = require("../../client");
    if (store.default.getState().api.apis.length < 1) {
      await store.default.dispatch.api.getApis({
        limit: 5,
        sort: { date: "DESC" },
      });
      await store.default.dispatch.api.getApisCount();
    }
  }
  return { whatever: "stuff" };
};

export default News;
